import { Component, inject } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  UsersClientProvider,
  PasswordResetTokenValidationState,
  PaswordResetCommand,
  ValidationResult,
} from "src/app/web-api/web-api";
import { finalize } from "rxjs/operators";
import { AlertService } from "src/app/services";
import {
  FormGroup,
  Validators,
  FormBuilder,
  AbstractControl,
} from "@angular/forms";
import { APP_TITLE_TOKEN } from "src/app/injection-tokens/app-title-token";

@Component({
    templateUrl: "./password-reset.component.html",
    styleUrls: ["./password-reset.component.scss"],
    standalone: false
})
export class PasswordResetComponent {
  private _router = inject(Router);
  private _route = inject(ActivatedRoute);
  private _client = inject(UsersClientProvider);
  private _fb = inject(FormBuilder);
  private _alertService = inject(AlertService);
  appTitle = inject(APP_TITLE_TOKEN);

  public validating = true;
  public tokenIsValid = false;
  public changedSuccesfully = false;
  public loading = false;
  public form: FormGroup = null;
  public isNewPassword = false;

  public constructor() {
    const token = this._route.snapshot.queryParamMap.get("token");
    if (!token) {
      this._router.navigateByUrl("/login");
      return;
    }
    this.isNewPassword =
      this._route.snapshot.queryParamMap.get("type") === "new";
    this._alertService.Clear();
    this._client
      .validatePasswordResetToken(token)
      .pipe(finalize(() => (this.validating = false)))
      .subscribe((result) => {
        switch (result.state) {
          case PasswordResetTokenValidationState.InvalidToken:
          case PasswordResetTokenValidationState.TokenExpired:
            this._alertService.Error(result.message);
            break;

          case PasswordResetTokenValidationState.Valid:
            this.tokenIsValid = true;
            this.form = this._fb.group({
              token: [token, Validators.required],
              newPassword: ["", Validators.required],
              confirmPassword: [
                "",
                Validators.compose([
                  Validators.required,
                  this._PasswordsMatchValidator.bind(this),
                ]),
              ],
            });
            break;
        }
      });
  }

  private _PasswordsMatchValidator(control: AbstractControl) {
    if (!this.form) {
      return null;
    }
    const valid = this.form.value.newPassword === control.value;
    if (valid) {
      return null;
    }
    return {
      error: $localize`:@@PasswordReset_PasswordConfirmValidation:Must match the password field`,
    };
  }

  public OnSubmit() {
    if (!this.form.valid) {
      return;
    }
    const command = new PaswordResetCommand();
    command.init({
      token: this.form.value.token,
      newPassword: this.form.value.newPassword,
    });
    this.loading = true;
    this._client
      .passwordReset(command)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(
        () => {
          this._router.navigate(["/login"]);
          this._alertService.Success(
            this.isNewPassword
              ? $localize`:@@PasswordReset_SuccessNew:The password could be saved succesfully!`
              : $localize`:@@PasswordReset_Success:The password could be changed succesfully!`
          );
          this.changedSuccesfully = true;
          this._alertService.showSnackbar(
            this.isNewPassword
              ? $localize`:@@PasswordReset_SuccessNew:The password could be saved succesfully!`
              : $localize`:@@PasswordReset_Success:The password could be changed succesfully!`,
            { duration: "short" }
          );
        },
        (error) => {
          if (error instanceof ValidationResult) {
            let msgs = "";
            for (const prop of error.properties) {
              msgs += prop.failures.join("\n-") + "\n";
            }
            this._alertService.Error(msgs);
            return;
          }
          console.log(error);
        }
      );
  }
}
